if (!customElements.get('sticky-quick-add-aks')) {
  customElements.define(
    'sticky-quick-add-aks',
    class StickyQuickAddAks extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector('.sticky-quick-add-aks__select');
        this.variantIdInput = this.querySelector('.sticky-quick-add-aks__variant-id');
        this.submitButton = this.querySelector('.sticky-quick-add-aks__submit');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (this.select) {
          this.select.addEventListener('change', this.onVariantChange.bind(this));
        }
      }

      onVariantChange() {
        const selectedOption = this.select.options[this.select.selectedIndex];
        if (!selectedOption || !this.variantIdInput || !this.submitButton) return;

        this.variantIdInput.value = selectedOption.value;

        const isAvailable = !selectedOption.disabled;
        this.submitButton.toggleAttribute('disabled', !isAvailable);
        if (this.submitButtonText && window.variantStrings) {
          this.submitButtonText.textContent = isAvailable
            ? window.variantStrings.addToCart
            : window.variantStrings.soldOut;
        }
      }
    }
  );
}
